import { Row, Col, Icon, Button } from 'antd';
import { HomeCaptchaForm, RegistrationStatus } from '@bit/ui-common.ui-components/ss-components';
import * as config from './formConfig';
import { ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import AfspAcknowledgment from '@bit/ui-common.ui-components/afsp/react/components/AfspAcknowledgement';  

const
{ linkedFields } = ssFormValidationUtils,
{ setEnvPrefix } = ssCommonUtils;

class StepStatusIndicator extends React.Component {
    constructor(props) { super(props); }

    static getType = t => { switch(t) {
        case 'Personal': return 'user';
        case 'Passport': return 'idcard';
        case 'ID & Email': return 'mail';
        case 'Security': return 'lock';
        case 'Signature': return 'edit';
        default: return 'question-circle';
    }}

    render() {
        const { config, status, goToStep } = this.props;

        return config == null ? null : (
            <Col span={4}>
                {status === 'error' ? (
                    <div className='home-cand-reg-step-status-indicator-text-error'>
                        <Icon type='close-circle' style={{ marginRight: '6px' }} />
                        {'Incomplete'}
                    </div>
                ) : (
                    <div className='home-cand-reg-step-status-indicator-text-completed'>
                        <Icon type='check-circle' style={{ marginRight: '6px' }} />
                        {'Completed'}
                    </div>
                )}
                <div className={status === 'error'
                    ? 'home-cand-reg-step-status-indicator-error'
                    : 'home-cand-reg-step-status-indicator-success'
                } onClick={() => goToStep(config.step)}>
                    <Icon type={StepStatusIndicator.getType(config.title)} style={{ marginRight: '8px' }} />
                    <div className='home-cand-reg-step-status-indicator-title'>
                        {config.title}
                    </div>
                </div>
            </Col>
        );
    }
}

export default class Submit extends React.Component {
    state = {
        showAcknowledgement: false,
        captchaInput: ''
    };

    constructor(props) { 
        super(props); 
        this.updateCaptchaField = this.updateCaptchaField.bind(this);
    }

    static getConfig(step) {
        for(let c in config)
            if(config[c].step === step)
                return config[c];
        return null;
    }
   
    static goToStep(controls, step) {
        const { changeStep } = controls.layout;
        changeStep(null, step - 1);
    }

    componentDidMount = () => this.setStepStatus();
    componentDidUpdate = prev => {
        this.setStepStatus(prev)
    };

    setStepStatus(prev) {
        const
        { registrationForm, services } = this.props,
        getStatus = (cfg, data) => {
            let status;
            for(let p in data) {
                if(p.indexOf('_status') !== -1 && data[p] === '') {
                    for(let p in cfg.formItems) {
                        let c = cfg.formItems[p];
                        for(let r in c.rules) {
                            let rule = c.rules[r];
                            if(rule.name === 'isRequired') {
                                status = 'error';
                                break;
                            }
                        }
                        if(status != null) break;
                    }
                }
                else if(p.indexOf('_status') !== -1 && data[p] === 'error') status = 'error';
                else if(p.indexOf('_status') !== -1 && data[p] === 'required') status = 'error';

                if(status != null) break;
            }
            if(status == null) status = 'success';
            return status;
        };

        let formConfig = {...config};

        delete formConfig.linkedFormFields;
        formConfig.passport = linkedFields(
            registrationForm[formConfig.passport.key],
            {...formConfig.passport},
            config.linkedFormFields
        );

        Object.keys(formConfig).map(k => {
            let
            cfg = formConfig[k],
            cStatus = getStatus(cfg, registrationForm[cfg.key]);
            if(prev == null) services.updateCandRegistrationStepStatus(`step${cfg.step}`, cStatus);
            else {
                let pStatus = getStatus(cfg, prev.registrationForm[cfg.key]);
                if(cStatus !== pStatus) services.updateCandRegistrationStepStatus(`step${cfg.step}`, cStatus);
            }
        });


    }
    registrationAccept(services, registrationForm) {
        services.candidateRegistrationSubmission(registrationForm);
        services.clearCandidateRegistrationData();
    }
    componentWillUnmount() {
        const { services } = this.props;
        services.resetCaptchaValidation();
    }

    goToStep = step => {
        const { changeStep } = this.props.controls.layout;
        changeStep(null, step);
    }

    updateCaptchaField(e){
        const
        { services } = this.props,
        value = e.target.value;
        if(this.state.captchaInput.length !== 8 && value.length === 8){
            services.checkCaptcha(value);
        }
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:value},
                    captchaInput: value
                     }
           });
    }

    render() {
        const
        { candidate, services, controls, captcha, registrationForm, passwordReset } = this.props,
        { registrationStatus, registrationRequest, showPasswordResetModal } = candidate,
        { status } = captcha.validation,
        regStatus = registrationRequest.status,
        regCode = registrationRequest.code,
        {captchaInput} = this.state;

        return (
            <div>
                <RegistrationStatus
                    type='candidate'
                    status={regStatus !== 'pending' && regStatus !== 'success' ? regCode : regStatus}
                    visible={regStatus != null}
                    failureCallback={code => {
                        services.clearCandidateRegistrationRequest();
                        switch(code) {
                            case 409:
                                services.markFieldErrorCode(409, 'candidateEmail', 'emailAddress');
                                this.goToStep(3);
                                break;

                            case 410:
                                services.markFieldErrorCode(409, 'candidateEmail', 'emailAddress');
                                services.markFieldErrorCode(412, 'candidateEmail', 'userId');
                                this.goToStep(3);
                                break;

                            case 412:
                                services.markFieldErrorCode(412, 'candidateEmail', 'userId');
                                this.goToStep(3);
                                break;

                            case 422:
                                window.location.href = setEnvPrefix('/home');
                                break;

                            default: window.location.href = setEnvPrefix('/home');
                        }
                    }}
                    showPasswordResetModal={showPasswordResetModal}
                    toggleModalPasswordResetRequest={() => services.toggleModalPasswordResetRequest()}
                   
                    passwordResetRequest={passwordReset.request}
                    form={registrationForm}
                    storeForm={services.storeForm}
                    storeFormField={services.storeFormField}
                    captcha={captcha}
                    captchaServices={{
                        validateCaptcha: services.validateCaptcha,
                        checkCaptcha: services.checkCaptcha,
                        updateCaptchaField: services.updateCaptchaField,
                        loadCaptcha: services.loadCaptcha,
                        resetCaptchaValidation: services.resetCaptchaValidation,
                        setValidated:services.setValidated
                    }}
                    modalOnClick={() => {
                        services.toggleModalPasswordResetRequest();
                        services.resetCaptchaValidation();
                        services.clearRequestPasswordReset();
                    }}
                   
                    submitPasswordReset={field => services.requestPasswordReset(field, captcha.field)}
                />
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '45px' }}>
                    <Col span={21}>
                        <Row type='flex' justify='space-around' align='middle' gutter={10}>
                            {Object.keys(candidate.stepStatus).map((k, i) => <StepStatusIndicator
                                key={i}
                                status={candidate.stepStatus[k]}
                                config={Submit.getConfig(parseInt(k.charAt(k.length - 1)))}
                                goToStep={step => Submit.goToStep(controls, step)}
                            />)}
                        </Row>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={21} >
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <HomeCaptchaForm
                                        state={captcha}
                                        updateCaptchaField={this.updateCaptchaField}
                                        captchaInput={captchaInput}
                                        services={services}
                                        disabled={registrationStatus === 'error' ? true : false} />
                            </Col>
                        </Row>                       
                        <AfspAcknowledgment showAcknowledgement = {this.state.showAcknowledgement} role = "c" 
                        description = "Candidate registration acknowledgement statement" 
                        onDeny= {() => this.setState({ showAcknowledgement : false})} 
                        onAccept= {() =>{
                        services.candidateRegistrationSubmission(registrationForm, captchaInput);
                        services.clearCandidateRegistrationData() }} denyButton={true}/>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <Button
                                    type='primary'
                                    id='candidate-registration-submit'
                                    icon='check-circle'
                                    disabled={status === 'success' && registrationStatus === 'success' ? false : true}
                                    style={{ width: '241px', borderRadius: '20px' }}
                                    onClick={() => {
                                        this.setState({ showAcknowledgement : true});
                                        this.componentDidUpdate();
                                        console.log("in the click");
                                    }}
                                >
                                    {'Submit'}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}